import { isValidElement, type ReactNode } from 'react';

export const slugify = (el: ReactNode): string => {
  let string = '';
  if (typeof el === 'string') {
    string += el;
  } else if (typeof el === 'number') {
    string += el.toString();
  } else if (Array.isArray(el)) {
    string += el.map(slugify).join('');
  } else if (
    isValidElement(el) &&
    'props' in el &&
    'children' in (el.props as Record<string, ReactNode>)
  ) {
    string += slugify((el.props as Record<string, ReactNode>).children);
  } else {
    string += '';
  }
  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};
